var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"fill":"none","stroke":"rgb(255, 255, 255)","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.25"},"d":"M3,18H21M3,12H21M3,6H21","id":"primary"}));
}

Menu.defaultProps = {"data-icon-name":"menu-alt","data-style":"line","icon_origin_id":"20532","viewBox":"0 0 24 24","id":"menu-alt","className":"icon line","width":"48","height":"48"};

module.exports = Menu;

Menu.default = Menu;
